// AddAgent.jsx
import React from "react";
import AgentForm from "../../components/AgentForm";
import {
  useAddAgentLanguagesMutation,
  useAddAgentMutation,
} from "../../redux/api/agentsApi";
import { useUploadImageMutation } from "../../redux/api/filesApi";
import { useNavigate } from "react-router-dom";
import { AGENTS_ROUTE } from "../../constants/routes";
import { errorToast } from "../../constants/toast";

export default function AddAgent() {
  const [addAgent, { isLoading: isLoadingAddAgent }] = useAddAgentMutation();
  const [addAgentLanguages, { isLoading: isLoadingAddLanguages }] =
    useAddAgentLanguagesMutation();
  const [uploadImage] = useUploadImageMutation();
  const navigate = useNavigate();

  // helper: true if value is a File or Blob
  const isFileLike = (v) =>
    typeof v === "object" &&
    v !== null &&
    (v instanceof File || v instanceof Blob);

  const uploadImg = async (fileOrBlob, imageType, tag) => {
    const fd = new FormData();
    // append with a filename so backend can infer extension from Blob, too
    const filename =
      fileOrBlob instanceof File
        ? fileOrBlob.name
        : `${imageType}-${Date.now()}.jpg`;
    fd.append("", fileOrBlob, filename);
    const url = await uploadImage({ image: fd, imageType, tag }).unwrap();
    return url; // backend returns URL string
  };

const onSubmit = async (data) => {
  try {
    const {
      agentLanguages,
      agentimage,
      agentimageFile,
      nicimg,
      passportFile,
      contractFile,
      ...rest
    } = data;

    const finalPayload = { ...rest };

    // --- Agent image ---
    if (isFileLike(agentimageFile)) {
      const url = await uploadImg(agentimageFile, "agentimg", "img");
      finalPayload.agentimage = url;
    } else if (typeof agentimage === "string" && agentimage.trim()) {
      finalPayload.agentimage = agentimage.trim();
    } else {
      finalPayload.agentimage = "";
    }

    // --- NIC/ID image ---
    if (isFileLike(nicimg)) {
      const url = await uploadImg(nicimg, "agentid", "img");
      finalPayload.nicimg = url;
    } else if (typeof nicimg === "string" && nicimg.trim()) {
      finalPayload.nicimg = nicimg.trim();
    } else {
      finalPayload.nicimg = "";
    }

    // --- Passport file (API expects "passportimg") ---
    if (isFileLike(passportFile)) {
      const url = await uploadImg(passportFile, "agentpass", "img");
      finalPayload.passportimg = url;
    } else {
      finalPayload.passportimg = "";
    }

    // --- Contract file (API expects "contractpdf") ---
    if (isFileLike(contractFile)) {
      const url = await uploadImg(contractFile, "contract", "pdf");
      finalPayload.contractpdf = url;
    } else {
      finalPayload.contractpdf = "";
    }

    // --- Map dates to API keys ---
    finalPayload.idissuedate = rest.idIssueDate
      ? rest.idIssueDate.toISOString?.()
      : null;
    finalPayload.idexpdate = rest.idExpiryDate
      ? rest.idExpiryDate.toISOString?.()
      : null;
    finalPayload.passportissuedate = rest.passportIssueDate
      ? rest.passportIssueDate.toISOString?.()
      : null;
    finalPayload.passportexpdate = rest.passportExpiryDate
      ? rest.passportExpiryDate.toISOString?.()
      : null;

    // --- Create agent ---
    const res = await addAgent(finalPayload).unwrap();
    const postedAgentId = res.agentid;

    // --- Attach languages ---
    if (Array.isArray(agentLanguages) && agentLanguages.length) {
      await Promise.all(
        agentLanguages.map((lng) =>
          addAgentLanguages({ agentid: postedAgentId, languageid: lng.id })
        )
      );
    }

    navigate(AGENTS_ROUTE);
  } catch (err) {
    // if (err?.status === 409) return errorToast("Email already exists");
    return errorToast("Unknown Error Occurred");
  }
};



  return (
    <AgentForm
      title="Add Staff"
      onAddAgent={onSubmit}
      isSubmitting={isLoadingAddAgent || isLoadingAddLanguages}
    />
  );
}
